import { render, staticRenderFns } from "./SeparatorView.vue?vue&type=template&id=9ae8bb6c&scoped=true&"
import script from "./SeparatorView.vue?vue&type=script&lang=js&"
export * from "./SeparatorView.vue?vue&type=script&lang=js&"
import style0 from "./SeparatorView.vue?vue&type=style&index=0&id=9ae8bb6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae8bb6c",
  null
  
)

export default component.exports